import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Brain, FileText, ShieldCheck, Zap, Crosshair, Map } from 'lucide-react';
import { FAQAccordion } from './components/FAQAccordion';
import { TestimonialCarousel } from './components/TestimonialCarousel';
import { Countdown } from './components/Countdown';
import { PurchasePopup } from './components/PurchasePopup';
const COVER_MURDOKU = 'https://cdn.magicpatterns.com/uploads/avzypTqfjyDGkvE2n5EqaY/PORTADA_MURDOKU.webp';
const COVER_VIAJE = 'https://cdn.magicpatterns.com/uploads/d3mRg8WCDVPjbfZzPNAShc/MURDOKU_VIAJE_AL_PASADO.webp';
const PACK_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/e21U2i9cTMQ8d8beuW1Z2B/MURDOKUS.png';
const BONUS_SOFIA = 'https://cdn.magicpatterns.com/uploads/344VAQrNPzuUKCpmAnwFnr/EL_ASESINO_NO_ES_SOFIA.jpg';
const BONUS_SOPICIDIOS = 'https://cdn.magicpatterns.com/uploads/vyEtnnNFZ9oAC2Vw8ErYwt/SOPICIDIOS.webp';
const VIDEO_URL = 'https://cdn.magicpatterns.com/uploads/4wzELUP6qiRd981MUJi4s6/IMG_8693.MOV';
const CHECKOUT_URL = 'https://murdoku.impultienda.ar/checkout/pack-murdoku';
export function App() {
  const [showFloatingBtn, setShowFloatingBtn] = useState(false);
  const [currency, setCurrency] = useState<'USD' | 'ARS'>('USD');
  useEffect(() => {
    fetch('https://api.country.is/').then(res => res.json()).then(data => {
      if (data.country === 'AR') {
        setCurrency('ARS');
      }
    }).catch(err => console.error('Geolocation error:', err));
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowFloatingBtn(true);
      } else {
        setShowFloatingBtn(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    // Meta Pixel Code
    const win = window as any;
    if (!win.fbq) {
      win.fbq = function () {
        win.fbq.callMethod ? win.fbq.callMethod.apply(win.fbq, arguments) : win.fbq.queue.push(arguments);
      };
      if (!win._fbq) win._fbq = win.fbq;
      win.fbq.push = win.fbq;
      win.fbq.loaded = !0;
      win.fbq.version = '2.0';
      win.fbq.queue = [];
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    win.fbq('init', '1052676944287139');
    win.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen font-sans text-murdoku-dark bg-murdoku-cream overflow-x-hidden" data-id="element-0" data-mp="3bnuudfmeokln">
      
      {/* 1. Top Bar */}
      <div className="bg-murdoku-red text-white text-center py-3 px-4 shadow-md sticky top-0 z-50" data-id="element-1" data-mp="3qd0tl3l8uatj">
        <div className="font-heading font-bold text-lg md:text-xl tracking-widest flex items-center justify-center gap-2" data-id="element-2" data-mp="3limqsg4951eu">
          <Zap size={20} className="animate-pulse text-yellow-300" data-id="element-3" data-mp="2swbs5b07hako" />
          <span data-id="element-4" data-mp="2stzcx5lu1ebb">OFERTA DE LANZAMIENTO</span>
          <Countdown data-id="element-5" data-mp="18dhopv1l8k1s" />
        </div>
        <div className="text-xs md:text-sm font-medium text-white/90 mt-1" data-id="element-6" data-mp="18cgh60js6fot">
          Acceso digital inmediato después de tu compra
        </div>
      </div>

      {/* 2. Hero Section */}
      <section className="relative bg-murdoku-purple text-white pt-12 pb-20 overflow-hidden" data-id="element-7" data-mp="yh6ct65wtw7v">
        <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-8" data-mp="13fg6fcbzkord"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-murdoku-orange rounded-full blur-[100px] opacity-20 -translate-y-1/2 translate-x-1/3" data-id="element-9" data-mp="1r3zim2y5ploq"></div>

        <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-10" data-mp="1w19bxtoo2hhu">
          <div className="flex flex-col md:grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-11" data-mp="1i2syzl07nur9">
            
            {/* Hero Image */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6
          }} className="order-1 md:order-2 flex justify-center w-full mx-auto" data-id="element-12" data-mp="1m70qfpy1zot6">
              <img src={PACK_IMAGE_URL} alt="Pack Murdoku Completo" className="w-full max-w-[500px] object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.6)]" fetchPriority="high" data-id="element-13" data-mp="qz8ghb9gdxsx" />
            </motion.div>

            {/* Hero Text */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="order-2 md:order-1 space-y-6" data-id="element-14" data-mp="c8j2y28is6lw">
              <h1 className="font-heading text-5xl md:text-7xl font-black leading-[1.1] text-white drop-shadow-md uppercase text-center md:text-left" data-id="element-15" data-mp="14v3tj0h68eoe">
                Dos libros.<br data-id="element-16" data-mp="vvgqka8sn0t8" />
                <span className="text-murdoku-orange" data-id="element-17" data-mp="vybam0nwajm4">160 misterios.</span><br data-id="element-18" data-mp="3kob2ubepzy3p" />
                ¿Podrás resolverlos todos?
              </h1>
              
              <p className="text-lg md:text-xl text-white/90 font-medium leading-relaxed text-center md:text-left" data-id="element-19" data-mp="3gm7p1g4kwhf9">
                Descubrí el pack completo de Murdoku y poné a prueba tu lógica, atención y capacidad de deducción con 160 acertijos de crímenes y misterio.
              </p>

              <div className="bg-black/20 p-5 rounded-2xl border border-white/10" data-id="element-20" data-mp="254v3no2xi2np">
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-base font-medium" data-id="element-21" data-mp="29vjwb6qch5of">
                  {['2 libros completos', '80 acertijos en cada libro', 'Soluciones incluidas', 'Descarga inmediata'].map((bullet, i) => <li key={i} className="flex items-start gap-2" data-id="element-22" data-mp="2jthqeauvxwoy" data-mpi={i}>
                      <CheckCircle2 className="text-murdoku-orange shrink-0 mt-0.5" size={20} data-id="element-23" data-mp="2jvu6eih31wzd" />
                      <span data-id="element-24" data-mp="2nts120tmhba5">{bullet}</span>
                    </li>)}
                  <li className="flex items-start gap-2 col-span-1 sm:col-span-2" data-id="element-25" data-mp="2su5xsmprwysv">
                    <CheckCircle2 className="text-murdoku-orange shrink-0 mt-0.5" size={20} data-id="element-26" data-mp="timwmuapoutr" />
                    <span data-id="element-27" data-mp="yhprxn0w3moj">BONUS DE REGALO: El Asesino No Es Sofía — libro completo.</span>
                  </li>
                  <li className="flex items-start gap-2 col-span-1 sm:col-span-2" data-id="element-28" data-mp="21sdfk594rthr">
                    <CheckCircle2 className="text-murdoku-orange shrink-0 mt-0.5" size={20} data-id="element-29" data-mp="1wtiyp8uq4f0a" />
                    <span data-id="element-30" data-mp="2asikm8quqfsr">BONUS DE REGALO: Sopicidios — libro completo.</span>
                  </li>
                </ul>
              </div>

              <div className="pt-4 flex flex-col items-center md:items-start" data-id="element-31" data-mp="25ruo57jut6r5">
                <div className="flex items-baseline gap-4 mb-3" data-id="element-32" data-mp="2kp53irzmaws5">
                  <span className="text-5xl font-black text-murdoku-orange font-heading" data-id="element-33" data-mp="2frv90xxdfuxg">
                    {currency === 'ARS' ? '$21.990 ARS' : 'USD 14,99'}
                  </span>
                  <span className="text-xl text-white/50 line-through decoration-murdoku-red decoration-2 font-bold" data-id="element-34" data-mp="2phesa4ozxqsu">
                    {currency === 'ARS' ? '$39.980' : 'USD 24,99'}
                  </span>
                </div>

                <a href="#compra" onClick={e => {
                e.preventDefault();
                document.getElementById('compra')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="w-full md:w-auto bg-murdoku-orange hover:bg-orange-500 text-white font-black text-xl md:text-2xl py-5 px-12 rounded-xl shadow-[0_8px_0_#C2410C] hover:shadow-[0_4px_0_#C2410C] hover:translate-y-1 transition-all duration-200 flex items-center justify-center uppercase font-heading tracking-wider text-center" data-id="element-35" data-mp="2yiw43avdf6bq">
                  QUIERO ACCEDER
                </a>

                <div className="flex items-center gap-2 mt-5 text-sm text-white/80 font-medium" data-id="element-36" data-mp="344wwz32k6lf9">
                  <ShieldCheck size={16} className="text-green-400" data-id="element-37" data-mp="2pg0hwm234855" />
                  <span data-id="element-38" data-mp="2udsie4gsp2ky">Pago seguro · Producto digital · Acceso inmediato</span>
                </div>

                <div className="mt-4 inline-block bg-white/10 border border-white/20 text-white px-4 py-2 rounded-lg text-sm font-semibold text-center" data-id="element-39" data-mp="2gdr8y0mgsmtv">
                  ⚠️ No son muestras ni casos gratuitos: recibís ambos libros completos.
                </div>
              </div>
            </motion.div>

          </div>
        </div>
      </section>

      {/* Video Section */}
      

      {/* 4. Primer Libro */}
      <section className="py-20 bg-murdoku-cream relative overflow-hidden border-y border-gray-200" data-id="element-40" data-mp="2qw67hokiz8ij">
        <div className="max-w-6xl mx-auto px-6" data-id="element-41" data-mp="2lx32230mv0a1">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-42" data-mp="2m0h2v6tnf1fd">
            <div className="order-1 md:order-1 flex justify-center relative" data-id="element-43" data-mp="2hy2k0mpzc1o3">
              <div className="absolute inset-0 bg-murdoku-purple/5 rounded-full blur-3xl" data-id="element-44" data-mp="2d4rmjc724x8u"></div>
              <img src={COVER_MURDOKU} alt="Murdoku: 80 acertijos de lógica y asesinatos" className="w-full max-w-[450px] relative z-10 drop-shadow-2xl transform -rotate-2" data-id="element-45" data-mp="287rh93i17yis" />
            </div>
            <div className="order-2 md:order-2 space-y-6" data-id="element-46" data-mp="1y8s7tipfzyuq">
              <div className="inline-block bg-murdoku-purple text-white font-bold px-4 py-1.5 rounded-full text-sm tracking-wider uppercase" data-id="element-47" data-mp="1yad011oab5pf">
                LIBRO COMPLETO · 80 ACERTIJOS
              </div>
              <h3 className="font-heading text-4xl md:text-6xl font-black text-murdoku-dark uppercase leading-none" data-id="element-48" data-mp="dqhmbjgh5wpv">
                Murdoku: <br data-id="element-49" data-mp="ipb25ij8hzt7" /><span className="text-murdoku-purple" data-id="element-50" data-mp="ipaztbvrhnq1">80 acertijos de lógica y asesinatos</span>
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-51" data-mp="nncme6sec569">
                Analizá la ubicación de cada sospechoso y utilizá la lógica para reconstruir la escena del crimen. Solo una combinación conduce a la verdad.
              </p>
              <ul className="space-y-3" data-id="element-52" data-mp="3r31hqiavjxqr">
                {['80 casos de dificultad progresiva.', 'Escenarios ilustrados y detallados.', 'Soluciones incluidas al final.'].map((item, i) => <li key={i} className="flex items-center gap-3 bg-white p-3 rounded-xl border border-gray-100 shadow-sm" data-id="element-53" data-mp="4r4cgpofv64m" data-mpi={i}>
                    <Crosshair className="text-murdoku-purple shrink-0" size={20} data-id="element-54" data-mp="33dz2fh3pqgzf" />
                    <span className="font-semibold text-gray-800" data-id="element-55" data-mp="38ctkuhxrq3j0">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Segundo Libro */}
      <section className="py-20 bg-murdoku-orange text-white relative overflow-hidden" data-id="element-56" data-mp="2k81at608tdfv">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-57" data-mp="2p388nx6tznwv"></div>
        <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-58" data-mp="2u32x7u34w1er">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-59" data-mp="1wh5m4hr32ycu">
            <div className="order-2 md:order-1 space-y-6" data-id="element-60" data-mp="1wesxjlqtlpqt">
              <div className="inline-block bg-white text-murdoku-orange font-bold px-4 py-1.5 rounded-full text-sm tracking-wider uppercase shadow-md" data-id="element-61" data-mp="21gibb95fghil">
                LIBRO COMPLETO · 80 ACERTIJOS NUEVOS
              </div>
              <h3 className="font-heading text-4xl md:text-6xl font-black text-white uppercase leading-none" data-id="element-62" data-mp="2b7mnk13pxo9q">
                Murdoku: <br data-id="element-63" data-mp="1ip8zuuc3jiod" /><span className="text-murdoku-dark" data-id="element-64" data-mp="1ip8vyj8z6yj3">Viaje al Pasado</span>
              </h3>
              <p className="text-lg text-white/90 leading-relaxed" data-id="element-65" data-mp="3vzih7x3wrrma">
                Viajá a escenarios históricos llenos de secretos. Aplicá la lógica en cantinas, palacios y aldeas para descubrir al culpable.
              </p>
              <ul className="space-y-3" data-id="element-66" data-mp="3my14moppm82c">
                {['80 acertijos completamente nuevos.', 'Misterios en diferentes épocas.', 'No repite casos del primer libro.'].map((item, i) => <li key={i} className="flex items-center gap-3 bg-black/10 p-3 rounded-xl border border-white/10 backdrop-blur-sm" data-id="element-67" data-mp="3d0mnemvypf8z" data-mpi={i}>
                    <Map className="text-white shrink-0" size={20} data-id="element-68" data-mp="389o91sujar8d" />
                    <span className="font-semibold text-white" data-id="element-69" data-mp="348cfxdcgbnvf">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="order-1 md:order-2 flex justify-center relative" data-id="element-70" data-mp="2zaavanzdnghu">
              <img src={COVER_VIAJE} alt="Murdoku: Viaje al Pasado" className="w-full max-w-[450px] relative z-10 drop-shadow-2xl transform rotate-2" data-id="element-71" data-mp="2uaoi2ejju091" />
            </div>
          </div>
        </div>
      </section>

      {/* 6. Aclaración */}
      <section className="py-16 bg-murdoku-dark text-white relative" data-id="element-72" data-mp="2flv799p2jlsc">
        <div className="max-w-5xl mx-auto px-6 text-center" data-id="element-73" data-mp="2kmswg68hxg3c">
          <h2 className="font-heading text-4xl md:text-5xl font-black mb-6 uppercase text-murdoku-red" data-id="element-74" data-mp="2kk6j1pyxc6d7">
            Recibís los libros completos
          </h2>
          <p className="text-xl md:text-2xl font-medium text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed border-b border-white/10 pb-10" data-id="element-75" data-mp="2aovbpspui1fh">
            Este pack <span className="text-white font-bold" data-id="element-76" data-mp="33cr4imcan96z">no contiene los casos gratuitos, demostraciones o muestras</span> que pueden encontrarse en internet. La compra incluye los dos libros completos, con 80 acertijos en cada uno y 160 desafíos en total.
          </p>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-77" data-mp="2tl4lw4xmm7u7">
            <div className="bg-white/5 border border-white/10 p-8 rounded-2xl" data-id="element-78" data-mp="3hcjq638yqz83">
              <FileText className="mx-auto text-murdoku-orange mb-4" size={40} data-id="element-79" data-mp="3m3a07tsc3q94" />
              <h4 className="font-heading font-bold text-2xl mb-2" data-id="element-80" data-mp="1aojggmzlqutj">2 libros digitales completos</h4>
              <p className="text-gray-400 text-sm" data-id="element-81" data-mp="15pga8z7vyijz">No son capítulos sueltos ni versiones reducidas.</p>
            </div>
            <div className="bg-white/5 border border-white/10 p-8 rounded-2xl" data-id="element-82" data-mp="1kevz29nuwdx1">
              <Brain className="mx-auto text-murdoku-purple mb-4" size={40} data-id="element-83" data-mp="1ff9jhtkk2ll2" />
              <h4 className="font-heading font-bold text-2xl mb-2" data-id="element-84" data-mp="1fhckt9r5s153">160 acertijos en total</h4>
              <p className="text-gray-400 text-sm" data-id="element-85" data-mp="rpxbgx0ysjkc">80 casos en cada libro listos para resolver.</p>
            </div>
            <div className="bg-white/5 border border-white/10 p-8 rounded-2xl" data-id="element-86" data-mp="msyn6v3zf6u2">
              <CheckCircle2 className="mx-auto text-green-400 mb-4" size={40} data-id="element-87" data-mp="11p667s3nm27r" />
              <h4 className="font-heading font-bold text-2xl mb-2" data-id="element-88" data-mp="wnytrfqkgeur">Soluciones incluidas</h4>
              <p className="text-gray-400 text-sm" data-id="element-89" data-mp="2d1p2x0wjltb9">Podrás comprobar cada investigación al final.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 9. Ideal Para */}
      <section className="py-20 bg-white border-t border-gray-200" data-id="element-90" data-mp="hnv32jw2fnbb">
        <div className="max-w-4xl mx-auto px-6" data-id="element-91" data-mp="mlmttakz53dx">
          <div className="bg-murdoku-purple text-white rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-92" data-mp="mmg3ajbbi6zr">
            <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-93" data-mp="qpm7llevdo3l"></div>
            <div className="relative z-10" data-id="element-94" data-mp="vo5ubo1af3x0">
              <h2 className="font-heading text-4xl md:text-5xl font-black mb-8 text-center uppercase text-murdoku-orange" data-id="element-95" data-mp="10lp7ekm91and">
                Este pack es para vos si…
              </h2>
              <ul className="grid md:grid-cols-2 gap-4 text-lg font-medium" data-id="element-96" data-mp="15iflx3ieny6o">
                {['Te gustan los sudokus y juegos de lógica.', 'Disfrutás los misterios y casos criminales.', 'Querés entrenar la mente mientras te entretenés.', 'Te gusta resolver desafíos con amigos o en pareja.'].map((item, i) => <li key={i} className="flex items-start gap-3 bg-black/20 p-4 rounded-xl" data-id="element-97" data-mp="1ja2mvgnaluvs" data-mpi={i}>
                    <CheckCircle2 className="text-murdoku-orange shrink-0 mt-0.5" size={24} data-id="element-98" data-mp="1o95qqxrjdv26" />
                    <span data-id="element-99" data-mp="1ygi0939tzeom">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 11. Testimonios */}
      <section className="py-20 bg-murdoku-cream overflow-hidden" data-id="element-100" data-mp="1oi2dtdlr0tlg">
        <div className="max-w-6xl mx-auto px-6 text-center mb-12" data-id="element-101" data-mp="1kfp98siqn1q9">
          <h2 className="font-heading text-4xl md:text-5xl font-black text-murdoku-dark mb-4 uppercase" data-id="element-102" data-mp="1khihgc901u0d">
            Lo que dicen quienes ya lo compraron
          </h2>
        </div>
        <TestimonialCarousel data-id="element-103" data-mp="2c7dg4ziqyw1p" />
      </section>

      {/* Nueva Sección de Bonus */}
      <section className="py-16 md:py-20 bg-white border-t border-gray-200" data-id="element-104" data-mp="27eka88bjlho1">
        <div className="max-w-5xl mx-auto px-6" data-id="element-105" data-mp="23f337aggwcgr">
          <div className="text-center mb-12 md:mb-16" data-id="element-106" data-mp="23c759m4mdnsb">
            <h2 className="font-heading text-4xl md:text-5xl font-black text-murdoku-dark mb-4 uppercase" data-id="element-107" data-mp="2zx7r1bjiaajb">
              SOLO POR HOY: 2 LIBROS COMPLETOS DE REGALO
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-108" data-mp="t7dw9aysbjd8">
              Además de los dos libros de Murdoku, hoy también recibís estos dos libros digitales completos sin costo adicional.
            </p>
          </div>

          <div className="space-y-8 md:space-y-12" data-id="element-109" data-mp="jhkut2scwkmp">
            {/* Bloque 1: Sofía */}
            <div className="bg-murdoku-cream rounded-3xl p-6 md:p-12 shadow-lg border border-gray-100 flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-110" data-mp="ofw4ndiniv4x">
              <div className="w-full md:w-1/2 order-2 md:order-1 space-y-4 md:space-y-6" data-id="element-111" data-mp="fg956x9hfzei">
                <div className="inline-block bg-murdoku-red text-white font-bold px-3 py-1 md:px-4 md:py-1.5 rounded-full text-xs md:text-sm tracking-wider uppercase" data-id="element-112" data-mp="j9q6ocax4a0">
                  BONUS 1 · MEGACASO
                </div>
                <h3 className="font-heading text-3xl md:text-5xl font-black text-murdoku-dark uppercase leading-none" data-id="element-113" data-mp="1ux16g6p4ymef">
                  ¿PODRÁS DEMOSTRAR QUE SOFÍA ES INOCENTE?
                </h3>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-114" data-mp="3kdn08c8r2qze">
                  Analizá pistas y descartá miles de nombres para encontrar al verdadero responsable.
                </p>
                <ul className="space-y-2 md:space-y-3" data-id="element-115" data-mp="3u59gwo3uxi9j">
                  {['47.700 sospechosos.', '18 pistas clave.', 'Solución incluida.'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-116" data-mp="6zi6dcox0mvd" data-mpi={i}>
                      <CheckCircle2 className="text-murdoku-red shrink-0" size={20} data-id="element-117" data-mp="6xp1a1tyaaph" />
                      <span className="font-semibold text-gray-800 text-sm md:text-base" data-id="element-118" data-mp="2xdeaie47yau">{item}</span>
                    </li>)}
                </ul>
                <div className="pt-2 md:pt-4 flex items-center" data-id="element-119" data-mp="bybltanriny6">
                  <div className="inline-block border-2 border-murdoku-red text-murdoku-red font-black px-3 py-1.5 md:px-4 md:py-2 rounded-lg transform -rotate-2 text-sm md:text-base text-center leading-tight" data-id="element-120" data-mp="bws21a2wdurn">
                    HOY INCLUIDO<br className="md:hidden" data-id="element-121" data-mp="1rxbztoh4pwuz" /> DE REGALO
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 order-1 md:order-2 flex justify-center" data-id="element-122" data-mp="1wuu0krkzt5rw">
                <img src={BONUS_SOFIA} alt="El Asesino No Es Sofía" className="w-full max-w-[220px] md:max-w-[350px] rounded-xl shadow-2xl transform rotate-2" data-id="element-123" data-mp="21mc2bhuubadx" />
              </div>
            </div>

            {/* Bloque 2: Sopicidios */}
            <div className="bg-murdoku-dark text-white rounded-3xl p-6 md:p-12 shadow-lg flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-124" data-mp="18zr8maqw6m77">
              <div className="w-full md:w-1/2 order-1 md:order-1 flex justify-center" data-id="element-125" data-mp="1ivkwgqa2a24a">
                <img src={BONUS_SOPICIDIOS} alt="Sopicidios" className="w-full max-w-[220px] md:max-w-[350px] rounded-xl shadow-2xl transform -rotate-2" data-id="element-126" data-mp="1nuxhr6lab14r" />
              </div>
              <div className="w-full md:w-1/2 order-2 md:order-2 space-y-4 md:space-y-6" data-id="element-127" data-mp="2uddjtpm09i0m">
                <div className="inline-block bg-murdoku-red text-white font-bold px-3 py-1 md:px-4 md:py-1.5 rounded-full text-xs md:text-sm tracking-wider uppercase" data-id="element-128" data-mp="2z8j7otyyx6rc">
                  BONUS 2 · SOPAS DE LETRAS
                </div>
                <h3 className="font-heading text-3xl md:text-5xl font-black text-white uppercase leading-none" data-id="element-129" data-mp="dwxq76hseeyj">
                  EL ASESINO ESTÁ ESCONDIDO ENTRE LAS LETRAS
                </h3>
                <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-130" data-mp="3z1each0zfzd">
                  Buscá nombres, lugares y pistas dentro de las sopas de letras hasta descubrir al culpable.
                </p>
                <ul className="space-y-2 md:space-y-3" data-id="element-131" data-mp="3r37k55fxvc1y">
                  {['80 casos criminales.', 'Diferentes dificultades.', 'Soluciones incluidas.'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-132" data-mp="3m6zb89sc4f38" data-mpi={i}>
                      <CheckCircle2 className="text-murdoku-red shrink-0" size={20} data-id="element-133" data-mp="1pbukaustvucr" />
                      <span className="font-semibold text-white text-sm md:text-base" data-id="element-134" data-mp="1kektpbtpdcnc">{item}</span>
                    </li>)}
                </ul>
                <div className="pt-2 md:pt-4 flex items-center" data-id="element-135" data-mp="278j1ieem4574">
                  <div className="inline-block border-2 border-murdoku-red text-murdoku-red font-black px-3 py-1.5 md:px-4 md:py-2 rounded-lg transform rotate-2 text-sm md:text-base text-center leading-tight" data-id="element-136" data-mp="27acba2kiv5jc">
                    HOY INCLUIDO<br className="md:hidden" data-id="element-137" data-mp="1tgl2iwem7poo" /> DE REGALO
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 12. CTA Final */}
      <section id="compra" className="py-24 bg-gradient-to-b from-murdoku-purple to-murdoku-dark text-white relative overflow-hidden" data-id="element-138" data-mp="1ji59uozxw8d2">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-139" data-mp="1ekvllcoae2qt"></div>

        <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-140" data-mp="3dwy6mrck756l">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-141" data-mp="38xlj04dv5u2y">
            
            <div className="w-[90%] md:w-[50%] mx-auto order-1 flex justify-center" data-id="element-142" data-mp="38vimd1i7h2p9">
              <img src={PACK_IMAGE_URL} alt="Pack Murdoku Completo" className="w-full max-w-[500px] object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.8)]" loading="lazy" data-id="element-143" data-mp="3hedigl662fzp" />
            </div>

            <div className="w-full md:w-[50%] text-center md:text-left order-2" data-id="element-144" data-mp="3q7pft5bcqyf1">
              <h2 className="font-heading text-5xl md:text-6xl font-black mb-6 text-white uppercase leading-[1.1]" data-id="element-145" data-mp="3v4payl6nygrd">
                Dos aventuras completas.<br data-id="element-146" data-mp="2yi4745mng3je" />
                <span className="text-murdoku-orange" data-id="element-147" data-mp="32h3ahlsqfs8q">160 crímenes por resolver.</span>
              </h2>

              <div className="bg-white/10 backdrop-blur-md border border-white/20 p-8 rounded-3xl w-full" data-id="element-148" data-mp="37fwl96gmx557">
                <div className="flex items-baseline justify-center md:justify-start gap-4 mb-2" data-id="element-149" data-mp="3cfspn6t8uyla">
                  <span className="text-6xl font-black text-murdoku-orange font-heading" data-id="element-150" data-mp="mr07bds7lemq">
                    {currency === 'ARS' ? '$21.990 ARS' : 'USD 14,99'}
                  </span>
                  <span className="text-2xl text-white/50 line-through decoration-murdoku-red decoration-2 font-bold" data-id="element-151" data-mp="20mum5c974rx">
                    {currency === 'ARS' ? '$39.980' : 'USD 24,99'}
                  </span>
                </div>
                <p className="text-sm text-white/80 font-medium mb-8 text-center md:text-left" data-id="element-152" data-mp="by0zr8sq874x">
                  Precio especial del pack
                </p>

                <a href={CHECKOUT_URL} className="block w-full bg-murdoku-orange hover:bg-orange-500 text-white font-black text-xl md:text-2xl py-5 px-8 rounded-xl shadow-[0_8px_0_#C2410C] hover:shadow-[0_4px_0_#C2410C] hover:translate-y-1 transition-all duration-200 uppercase text-center font-heading tracking-wider" data-id="element-153" data-mp="3ffsvmy9zhb8e">
                  QUIERO EL PACK
                </a>

                <div className="flex flex-col items-center md:items-start gap-3 mt-6 text-sm text-white/80 font-medium" data-id="element-154" data-mp="3kd2m8h93zsxt">
                  <div className="flex items-center gap-2" data-id="element-155" data-mp="2rqq510xdg81r">
                    <ShieldCheck size={18} className="text-green-400" data-id="element-156" data-mp="2rq825lg7evkv" />
                    <span data-id="element-157" data-mp="177e9n0j4jpgr">Producto digital · Acceso inmediato · Pago seguro</span>
                  </div>
                  <div className="text-xs text-white/50" data-id="element-158" data-mp="1bzxpy5974yp9">
                    ⚠️ No se envía ningún producto físico. Los archivos se entregan digitalmente.
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 13. FAQ */}
      <section className="py-20 bg-white" data-id="element-159" data-mp="1q08dozf7lx67">
        <div className="max-w-4xl mx-auto px-6" data-id="element-160" data-mp="1uy06dvnohnbg">
          <h2 className="font-heading text-4xl md:text-5xl font-black text-center text-murdoku-dark mb-12 uppercase" data-id="element-161" data-mp="1uwp5q4pj4vok">
            Preguntas Frecuentes
          </h2>
          <FAQAccordion data-id="element-162" data-mp="1kzazsz18fpai" />
        </div>
      </section>

      {/* 14. Footer */}
      <footer className="bg-murdoku-dark text-white/70 py-16 border-t border-white/10" data-id="element-163" data-mp="5j3h42iyt028">
        <div className="max-w-6xl mx-auto px-6" data-id="element-164" data-mp="5lgadbu6awul">
          <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-10 mb-12" data-id="element-165" data-mp="9lqd8fmo5758">
            <div className="text-center md:text-left max-w-md" data-id="element-166" data-mp="pslgqs9yg0q6">
              <div className="flex items-center justify-center md:justify-start gap-3 mb-4" data-id="element-167" data-mp="l0lbqlf12hmq">
                <div className="bg-murdoku-purple p-2 rounded-lg" data-id="element-168" data-mp="g1qsjid5er23">
                  <Brain className="text-murdoku-orange" size={24} data-id="element-169" data-mp="fzxo89q0cix9" />
                </div>
                <h3 className="font-heading font-bold text-3xl text-white tracking-wide uppercase" data-id="element-170" data-mp="b4qmv8k7nqbi">
                  Atlas Digital Hub
                </h3>
              </div>
              <p className="text-lg text-white/90 font-medium mb-2" data-id="element-171" data-mp="13sw7zwf6fhbv">
                Productos digitales para aprender, crear y entretenerte
              </p>
              <p className="text-sm text-white/50 mb-4" data-id="element-172" data-mp="ur6hcst4cmf5">
                Tienda digital de recursos, libros y productos descargables
              </p>
            </div>

            <div className="flex flex-col items-center md:items-end gap-4 text-sm" data-id="element-173" data-mp="3jgmjv0o1y885">
              <a href="#" className="hover:text-white transition-colors" data-id="element-174" data-mp="3ffu8a0rpjr8p">Términos y Condiciones</a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-175" data-mp="1v0xtflyfskh3">Políticas de Privacidad</a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-176" data-mp="1z0y734dporn3">Contacto</a>
            </div>
          </div>

          <div className="pt-8 border-t border-white/10 text-center text-xs text-white/40 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-177" data-mp="23xyd5fak9ue7">
            <p data-id="element-178" data-mp="2dojakzei0svj">© {new Date().getFullYear()} Atlas Digital Hub. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>

      <PurchasePopup data-id="element-179" data-mp="2iqs4bxz73yyp" />
      
      <noscript data-id="element-180" data-mp="2mqisrv192302">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1052676944287139&ev=PageView&noscript=1" alt="" data-id="element-181" data-mp="2mq0yv52280vb" />
      </noscript>
    </div>;
}